<template>
  <!-- 하단 표시 영역 -->
  <footer
    class="footer d-grid bg-light d-flex p-3 mt-4 sticky-bottom text-center justify-content-center"
    :class="customClass"
  >
    <div class="footer-wrapper">
      <ul>
        <li>
          <a href="https://www.loc.gov/legal/" target="_blank" class="terms">Legal</a>
        </li>
      </ul>
      <div class="footer-images">
        <img
          src="@/tenants/NLS/assets/images/congress-gov.png"
          alt="congress gov image"
        />
        <img
          src="@/tenants/NLS/assets/images/copyright.png"
          alt="copy right image"
        />
      </div>
    </div>
  </footer>
  <!-- // 하단 표시 영역 -->
</template>

<script>
export default {
  name: "Footer",
  props: {
    customClass: {
      type: String,
      default: "",
    },
  },
};
</script>

<style scoped>
footer {
  color: #767474;
  background: #484646;
  font-weight: 500;
  position: fixed;
  bottom: 0;
  height: 100px;
  display: flex;
  align-items: center;
  border-top: 1px solid var(--color-grey-50, #808080);
}

.footer-wrapper {
  width: 1172px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.footer-wrapper ul {
  display: flex;
  list-style: none;   /* ✅ 불릿 제거 */
  margin: 0;          /* 기본 여백 제거 */
  padding: 0;
}

.footer-wrapper ul li {
  list-style: none;
}

.footer-wrapper ul li a {
  text-decoration: none;
  font-size: 12px;
  line-height: 18px;
  color: #242424;
  font-weight: normal;
  margin-right: 20px;
}

.footer-wrapper ul li a.terms {
  font-size: 14px;
  font-weight: bold;
}

.footer-images {
  display: flex;
  gap: 3rem;
}
</style>
